/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as shippingInfoActions from '../../actions';
import * as getCheckOutActions from '../../../FuncComp/actions';
import injectReducer from '../../../../utils/injectReducer';
import injectSaga from '../../../../utils/injectSaga';
import saga from '../../sagas';
import shippingInfo from '../../reducer';
import * as shippingInfoSelectors from '../../selectors/shippingInfoSelectors';
import { getZipCode } from '../../../Cart/selectors/cartSelectors';
import * as cartActions from '../../../../services/Cart/actions';
import getCheckOutDetails from '../../../FuncComp/reducer';
import ShippingOptionsComp from '../../../../components/Web/ShippingInfo/redesign/FunctionalRedesign/ShippingOptions';
import { getCurrentShippingValue, getSelectedShippingType, isISPUSelected } from '../../shippingHelper';

const mapStateToProps = (state) => {
  const shippingInfoState = state.shippingInfo;
  const shippingInfoDetails = state.shippingInfo.ShippingInfoDetails || {};
  const getCheckOutDetailsState = state.checkout || {};
  const shipmentNewLine = state.checkout?.shipment?.lines?.newLine1 || {};
  const shippingStoreInfo = state.checkout?.lineDetails?.lineInfo?.newLine1?.shipping?.storeInfo || {};

  const selectShippingData = shippingInfoSelectors.selectShippingDataFun(state);
  const { selectedShippingOption, openISPUModal } = state.shippingInfo;
  const storeLists = state.shippingInfo.storeList;
  // TO DO
  const cartDetailsFromCheckDetails = state.checkout.cart || {};
  const ISPUSelect = isISPUSelected(cartDetailsFromCheckDetails);
  const defaultValue = ISPUSelect || shipmentNewLine?.selectedOptionCode;
  // we dont require Cart
  const cartDetails = state.cartDetails && state.cartDetails.cartDetailsJson ? state.cartDetails.cartDetailsJson : {};
  const selectedValue = state.shippingInfo?.selectedValue;
  const isbillingInfoEdited = state.contactInfo && state.contactInfo.billingInfoEdited ? state.contactInfo.billingInfoEdited : false;
  const zipcode = getZipCode(state, isbillingInfoEdited);
  const shippingHeader = state && state.shippingInfo?.shippingHeader;

  const currrentValue = getCurrentShippingValue(cartDetailsFromCheckDetails);
  const { storeListUpdatedValue } = state.shippingInfo;
  const isISPUEligible = state.checkout?.shipment?.lines?.newLine1?.ispuEligible;
  const itemAvailableStores = state.shippingInfo?.itemAvailableStores || [];
  const showPickupInfoTab = state.shippingInfo?.showPickupInfoTab;
  const cradleResponseDetails = state.SessionValues?.shippingCradleValue;
  const dataSelectedFromISPUModel = state.shippingInfo?.dataSelectedFromISPUModel;
  const ISPUSelectedStoreFromModel = state.shippingInfo?.ISPUSelectedStoreFromModel;
  const selectOtherOption = state.shippingInfo?.selectOtherOption;
  const selectedExpressCheckout = state.shippingInfo?.selectedExpressCheckout;
  const removedWHWPlus = state.shippingInfo?.removedWHWPlus;
  // console.log("dataSelectedFromISPUModel", dataSelectedFromISPUModel);
  return {
    cradleResponseDetails,
    ISPUSelectedStoreFromModel,
    dataSelectedFromISPUModel,
    isISPUEligible,
    itemAvailableStores,
    showPickupInfoTab,
    selectShippingData,
    selectedValue,
    removedWHWPlus,
    selectOtherOption,
    selectedExpressCheckout,
    shippingInfoState,
    shippingInfoDetails,
    getCheckOutDetailsState,
    shipmentNewLine,
    shippingStoreInfo,
    selectedShippingOption: selectedShippingOption || {},
    cartDetails,
    shippingDescription:
      cartDetails && cartDetails?.shippingDetails && cartDetails?.shippingDetails?.[0] && cartDetails?.shippingDetails?.[0]?.shippingDescription,
    defaultSelectedSlot:
      currrentValue ||
      (shippingInfoDetails?.lines?.[0] &&
        shippingInfoDetails?.lines?.[0]?.shippingOptions &&
        getSelectedShippingType(
          shippingInfoDetails?.lines?.[0]?.shippingOptions,
          true,
          shippingInfoDetails && shippingInfoDetails?.lines?.[0]?.selectedOptionCode,
        )),
    shippingOption:
      shippingInfoDetails?.lines?.[0] &&
      shippingInfoDetails?.lines?.[0]?.shippingOptions &&
      getSelectedShippingType(
        shippingInfoDetails?.lines?.[0]?.shippingOptions,
        true,
        shippingInfoDetails && shippingInfoDetails?.lines?.[0]?.selectedOptionCode,
      ),
    selectedOptionCode: shippingInfoDetails && shippingInfoDetails?.lines?.[0]?.selectedOptionCode,
    storeLists,
    zipcode,
    isbillingInfoEdited,
    shippingHeader,
    openISPUModal,
    defaultValue,
    storeListUpdatedValue,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...shippingInfoActions, ...cartActions, ...getCheckOutActions }, dispatch);
}

const withReducer = compose(injectReducer({ key: 'shippingInfo', reducer: shippingInfo }, { key: 'checkout', reducer: getCheckOutDetails }));

const withConnect = connect(mapStateToProps, mapDispatchToProps);

//
const withSaga = compose(injectSaga({ key: 'shippingInfo', saga }));

// const withSaga = injectSaga({ key: 'shippingInfo', saga });

export default withRouter(compose(withSaga, withReducer, withConnect)(ShippingOptionsComp));
